export default __webpack_public_path__ + "static/media/automations.b5293b58.svg";